import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@learningblocks/shared-components/lib/RichText";

export function TitleCell(props) {
  return (
    <th className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_title_contents`}>
        <p>
          <RichText value={props.text} />
        </p>
      </div>
    </th>
  );
}

TitleCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
